import { AllowedFileType } from "../types/AllowedFileType.types";

export const DEFAULT_ACCEPTED_FILE_TYPES: AllowedFileType[] = [
	"dwg",
	"jpg",
	"png",
	"gif",
	"svg",
	"webp",
	"pdf",
	"doc",
	"docx",
	"xls",
	"xlsx",
	"csv",
	"ppt",
	"pptx",
	"txt",
	"rtf",
	"zip",
	"rar",
	"7z",
];

export const MIME_MAP: Record<AllowedFileType, Record<string, string[]>> = {
	dwg: { "image/vnd.dwg": [".dwg"] },
	jpg: { "image/jpeg": [".jpg", ".jpeg"] },
	png: { "image/png": [".png"] },
	gif: { "image/gif": [".gif"] },
	svg: { "image/svg+xml": [".svg"] },
	webp: { "image/webp": [".webp"] },

	pdf: { "application/pdf": [".pdf"] },

	doc: { "application/msword": [".doc"] },
	docx: {
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
			".docx",
		],
	},

	xls: { "application/vnd.ms-excel": [".xls"] },
	xlsx: {
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
			".xlsx",
		],
	},

	csv: { "text/csv": [".csv"] },

	ppt: { "application/vnd.ms-powerpoint": [".ppt"] },
	pptx: {
		"application/vnd.openxmlformats-officedocument.presentationml.presentation":
			[".pptx"],
	},

	txt: { "text/plain": [".txt"] },
	rtf: { "application/rtf": [".rtf"] },

	zip: { "application/zip": [".zip"] },
	rar: { "application/x-rar-compressed": [".rar"] },
	"7z": { "application/x-7z-compressed": [".7z"] },
};
